export const TABLE_COLUMNS = [
  {
    label: "Name",
    value: "name",
    removable: false,
  },
  {
    label: "Spend",
    value: "spend",
    removable: true,
    numeric: true,
  },
  {
    label: "Clicks",
    value: "clicks",
    removable: true,
    numeric: true,
  },
  {
    label: "Revenue",
    value: "revenue",
    removable: true,
    numeric: true,
  },
  {
    label: "Orders",
    value: "orders",
    removable: true,
    numeric: true,
  },
];

export const getStartingTableColumns = () => {
  return TABLE_COLUMNS.map(({ value }) => value);
};
